import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../app/store";
import { fetchCurrentCachedState, getSelectedCardName } from "../utils/Utils";
import { CLUSTER_OBJECTS, transformFilterData } from "./clusterSlice";

const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.token
  }`;
};

const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

const _hid = () => {
  const state = store.getState();
  return state?.orgReducer?.healthAnalysisID.uid;
};

const _contextualFilterObj = () => {
  const state = store.getState();
  return state?.clusterReducer?.contextualFilterObj;
};

export const getGraphObjectsFromInitialFilter = async () => {
  const cardName = getSelectedCardName();
  let initialFilterData = null;
  let graphItems = null;
  let zoneItems = null;

  const legendsKey = CLUSTER_OBJECTS?.[cardName?.key]?.legendsKey;
  const zonesKey = CLUSTER_OBJECTS?.[cardName?.key]?.zonesKey;

  const cachedInitialFilterData = fetchCurrentCachedState(
    store.getState().filter_data.queries,
  )?.getInitialFilterData;

  const isEmpty =
    cachedInitialFilterData != null
      ? Object.keys(cachedInitialFilterData)?.length === 0
      : true;

  if (!isEmpty) {
    graphItems = cachedInitialFilterData?.[legendsKey];
    zoneItems = cachedInitialFilterData?.[zonesKey];
  } else {
    initialFilterData = await store
      .dispatch(
        initialFilterDataSlice.endpoints.getInitialFilterData.initiate({
          headers: {
            Authorization: _authToken(),
            "Content-Type": "application/json",
          },
        }),
      )
      .unwrap();
    graphItems = initialFilterData?.data?.[legendsKey];
    zoneItems = initialFilterData?.data?.[zonesKey];
  }

  return { graphItems, zoneItems };
};

export const getContextualObjectsFromInitialFilter = async () => {
  const contextualFilterObj = _contextualFilterObj();
  let filterItems = null;
  let filterMap = null;

  const cachedInitialFilterData = fetchCurrentCachedState(
    store.getState().filter_data.queries,
  )?.getInitialFilterData;

  const isEmpty =
    cachedInitialFilterData != null
      ? Object.keys(cachedInitialFilterData)?.length === 0
      : true;

  const sourceData = !isEmpty
    ? cachedInitialFilterData
    : await store
        .dispatch(
          initialFilterDataSlice.endpoints.getInitialFilterData.initiate({
            headers: {
              Authorization: _authToken(),
              "Content-Type": "application/json",
            },
          }),
        )
        .unwrap();

  filterItems = sourceData?.[contextualFilterObj?.filterkey];

  if (filterItems?.data) {
    filterMap = new Map(filterItems.data.map((item) => [item.id, item]));
  }

  return { filterMap };
};

export const initialFilterDataSlice = createApi({
  reducerPath: "filter_data",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["filter_data"],
  endpoints: (build) => ({
    getInitialFilterData: build.query({
      query: ({ headers }) => ({
        url: `bank/${_orgClientId()}/drilldown/${_hid()}/${getSelectedCardName()?.key}/filter`,
        method: "POST",
        headers: headers,
        body: {
          filter: {},
          requid: _hid(),
          gte: "",
          lte: "",
          duration: "",
        },
      }),
      transformResponse: (response) => {
        return { ...response, data: transformFilterData(response?.data) };
      },
    }),
  }),
});

export const { useGetInitialFilterDataQuery } = initialFilterDataSlice;
